<template>
  <BaseStyle
    class="min-h-screen w-full flex flex-col items-center"
    :content-style="renderedPage.style"
  >
    <BaseStyle
      class="min-h-screen max-w-md w-full flex flex-col items-center justify-between"
      :content-style="renderedPage.bodyStyle"
    >
      <div class="w-full">
        <div
          v-if="page.headers.length > 0"
          :class="page.headerSticky && 'sticky top-0 z-20'"
        >
          <Content
            v-for="(content, index) in renderedPage.headers"
            :key="index"
            :content="content"
          />
        </div>
        <Content
          v-for="(content, index) in renderedPage.contents"
          :key="index"
          :content="content"
        />
      </div>
      <div
        v-if="page.footers.length > 0"
        class="w-full"
        :class="page.footerSticky && 'sticky bottom-0 z-20'"
      >
        <Content
          v-for="(content, index) in renderedPage.footers"
          :key="index"
          :content="content"
        />
      </div>
    </BaseStyle>
  </BaseStyle>
  <LoadingLayer v-if="loading" />
  <Dialog />
  <TheGlobalDialogs />
  <TheGlobalFileInput />
</template>

<script lang="ts">
import { defineComponent, PropType, toRefs } from 'vue';

import LoadingLayer from '@/components/LoadingLayer.vue';
import { useHandlebarsRender } from '@/hooks/use_handlebars_render';
import { useLoader } from '@/hooks/use_loader';
import { Page } from '@/models/page';

import BaseStyle from './BaseStyle.vue';
import Content from './Content.vue';
import Dialog from './Dialog.vue';
import TheGlobalDialogs from './TheGlobalDialogs.vue';
import TheGlobalFileInput from './TheGlobalFileInput.vue';

export default defineComponent({
  name: 'CommonPage',
  components: {
    BaseStyle,
    Content,
    LoadingLayer,
    Dialog,
    TheGlobalDialogs,
    TheGlobalFileInput,
  },
  props: {
    page: {
      type: Object as PropType<Page>,
      required: true,
    },
  },
  setup(props) {
    const { page } = toRefs(props);
    const { loading } = useLoader();
    const renderedPage = useHandlebarsRender(page);
    return {
      loading,
      renderedPage,
    };
  },
});
</script>

<style lang="scss" scoped>
.default-font {
  font-family: "Noto Sans JP";
}
</style>
